import React from 'react';
import { useConfigQuery } from 'api/feeds';

const WithFeatureFlag = (WrapperComponent) => {
  return function WithFeatureFlagComponent(props) {
    const { feature } = props;

    const { data } = useConfigQuery();

    if (data?.featureFlags?.[feature]?.enabled) {
      const featureFlagProps = data.featureFlags[feature];
      return <WrapperComponent {...props} {...featureFlagProps} />;
    }
    return null;
  };
};

export default WithFeatureFlag;
